import React from 'react'

const PersonalOrderNotFoundView = () => (
  <div>
    <p>Объект не найден.</p>
    Измените запрос или обратитесь в тех поддержку сервиса.
  </div>
)
export default PersonalOrderNotFoundView;
